// Random homepage greeting for owners + staff. Picked fresh on every mount
// (page reload / login / nav back to dashboard) so the welcome text feels
// alive instead of robotically repeating the same line forever.
//
// Substitutions:
//   {name}  →  the user's first name (caller supplies; falls back to "there")
//   {day}   →  the local weekday name in English (Monday, Tuesday, …)
//
// 4 of 18 messages use {day} — sprinkled in for variety without making every
// greeting feel like a calendar.

const GREETINGS = [
  // General warm
  'Welcome back, {name}.',
  'Hello, {name}.',
  'Hi {name}, ready to go?',
  'Good to see you, {name}.',
  "Glad you're here, {name}.",
  'Onwards, {name}!',
  "Hey {name}, let's get to it.",
  "Let's make today count, {name}.",
  'Hi {name}, your customers await.',
  'Hey there, {name}.',
  'Make it a good one, {name}.',
  'Look who\'s back — {name}.',
  'Doors open, {name}.',
  'Greetings, {name}.',

  // Day-aware
  "How's your {day}, {name}?",
  'Happy {day}, {name}!',
  '{day} mode, {name}.',
  '{day} hustle, {name}.',
] as const

const DAY_NAMES = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
]

/**
 * Pick one greeting at random and fill in `{name}` and `{day}`.
 *
 * Callers should memoize the result for the lifetime of the mounted page —
 * `useMemo(() => pickGreeting(name), [name])` — so the line is stable while
 * the dashboard is open. A fresh pick happens on the next mount (reload or
 * navigation back), which is exactly the cadence the owner asked for.
 */
export function pickGreeting(name: string): string {
  const trimmed = name.trim() || 'there'
  const template = GREETINGS[Math.floor(Math.random() * GREETINGS.length)]!
  return template
    .replace('{name}', trimmed)
    .replace('{day}', DAY_NAMES[new Date().getDay()]!)
}
